module.exports = __webpack_public_path__ + "media/images/front/sp/cancer-portal/banner-13b4b0982f6ca257f865656557934b96.png";